import { useListRoleAssignments } from "@/queries/group-queries";
import { useListProjectsByIds } from "@/queries/project-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { useMemo } from "react";

export function useGroupProjects(groupId: string) {
    const { data: assignments, isLoading: isLoadingAssignments } = useListRoleAssignments({
        resourceType: ResourceType.PROJECT,
        groupId,
    });

    const projectIds = useMemo(
        () => assignments?.assignments.map((a) => a.resourceId) ?? [],
        [assignments],
    );

    const { projects, isPending: isLoadingProjects } = useListProjectsByIds(projectIds, {
        enabled: projectIds.length > 0,
    });

    return {
        projects,
        isLoading: isLoadingAssignments || isLoadingProjects,
    };
}
